export const environment = {
  apiUrl: "https://itaperuna.pontobiometrico.com.br/api/app",
  production: false
};
